import script from "./ClearFiltersButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClearFiltersButton.vue?vue&type=script&setup=true&lang=ts"

import "./ClearFiltersButton.vue?vue&type=style&index=0&id=1d2fa8e3&lang=css"

const __exports__ = script;

export default __exports__